import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {exhaustMap, map} from 'rxjs/operators';
import {MemberFeeService} from '../../../../../../services/payments/member/member-fee.service';
import * as feesActions from './fees.actions';

@Injectable()
export class FeesEffects {
    constructor(private actions$: Actions, private memberFeeService: MemberFeeService){}

    listMemberFees$ = createEffect(() =>
        this.actions$.pipe(
            ofType(feesActions.listMemberFeesHash),
            exhaustMap(action => this.memberFeeService.listMemberFeesHash(action.idMemberHash).pipe(
                map(response => feesActions.listMemberFeesHashSuccess({listMemberFees: response}))
            )
            )
        ));
}
